import { cn } from '../../utils/cn';

/**
 * The tiny right-pointing triangle that marks the active entry in a list.
 *
 * Drawn at 5x7 rather than scaled from an icon set: at this size a stroked
 * glyph loses its point. Shared by the site header's nav and the product
 * page's variant columns, so the mark a reader learns in one place means the
 * same thing in the other.
 *
 * Callers that mark one row out of several should render it on every row and
 * hide the inactive ones with `invisible`, so the labels do not shift as the
 * selection moves.
 */
export const ActiveMarker = ({ className }: { className?: string }) => (
    <svg
        width="5"
        height="7"
        viewBox="0 0 5 7"
        className={cn('shrink-0', className)}
        aria-hidden
    >
        <path d="M0 0L5 3.5L0 7Z" fill="currentColor" />
    </svg>
);
